/* eslint-disable react/destructuring-assignment */
import { Interweave } from 'interweave';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setActiveModal } from '../../actions/modalActions';
import Accordion from '../../components/accordion';
import { IAccordionItem } from '../../components/accordion/accordion';
import RichTextStyleWrapper from '../../components/base/richTextStyleWrapper';
import BasicRtHero from '../../components/basicRtHero';
import ContentSectionTabs from '../../components/contentSectionTabs';
import CookieDeclaration from '../../components/cookieDeclaration';
import CtaBoxColumns from '../../components/ctaBoxes/ctaBoxColumns';
import CtaBoxesWithDescription from '../../components/ctaBoxes/ctaBoxesWithDescription';
import CtaIconBoxColumns from '../../components/ctaBoxes/ctaIconBoxColumns/ctaIconBoxColumns';
import RichTextAndIconBoxes from '../../components/ctaBoxes/richTextAndIconBoxes';
import CtaTextOnlyBox from '../../components/ctaTextOnlyBox';
import CtaTextOnlyBoxes from '../../components/ctaTextOnlyBoxes';
import CtaVerticalChecklistBoxes from '../../components/ctaVerticalChecklistBoxes';
import DynamicForm from '../../components/dynamicForm';
import IconTextList from '../../components/iconTextList';
import MediaList from '../../components/mediaList';
import NearestPostboxOrPostoffice from '../../components/nearestPostboxOrPostoffice';
import Newsletter from '../../components/newsletter';
import PriceListDisplay from '../../components/priceListDisplay';
import QuestionsAndAnswers from '../../components/questionsAndAnswers';
import ShowcaseSection from '../../components/showcaseSection';
import { NEWSLETTER_MODAL } from '../../constants/documentTypes/modals/modals';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

export const ContentSectionsMapper = (item: IPageViewModel) => {
	const dispatch = useDispatch<any>();
	switch (item.Type) {
		case 'richText': {
			return (
				<RichTextStyleWrapper>
					<Interweave content={item.Values.Content} allowElements />
				</RichTextStyleWrapper>
			);
		}
		case 'accordion': {
			const accordionItems: IAccordionItem[] = item.Values.Items.map(_item => ({
				Values: {
					Title: _item.Values.Title,
					Content: _item.Values.Content,
				},
				id: _item.Values.Title.trim(),
			}));
			return <Accordion title={item.Values.Title} items={accordionItems} />;
		}
		case 'showcaseSection': {
			return <ShowcaseSection content={item} />;
		}
		case 'ctaBoxes': {
			return <CtaBoxColumns boxes={item.Values.CtaBoxes} />;
		}
		case 'ctaBoxesWithDescription': {
			return <CtaBoxesWithDescription boxes={item.Values.Content} />;
		}
		case 'ctaIconBoxes': {
			return <CtaIconBoxColumns title={item.Values.Title} boxes={item.Values.IconBoxes} />;
		}
		case 'richTextAndCtaIconBoxes': {
			return <RichTextAndIconBoxes content={item.Values.Content} boxes={item.Values.IconBoxes} />;
		}
		case 'contentSectionTabs': {
			return <ContentSectionTabs tabs={item.Values.Tabs} useLinks={item.Values.UseLinks} />;
		}
		case 'mediaList': {
			return <MediaList folder={item.Values.Folder} />;
		}
		case 'iconInfoTextList': {
			return <IconTextList list={item.Values.InfoTexts} />;
		}
		case 'dynamicForm': {
			return (
				<DynamicForm
					form={item.Values.Form}
					formImage={item.Values.FormImage}
					formHeadline={item.Values.FormHeadline}
				/>
			);
		}
		case 'qAPicker': {
			return <QuestionsAndAnswers items={item.Values.Questions} />;
		}
		case 'priceListDisplay': {
			return <PriceListDisplay display={item.Values} />;
		}
		case 'nearestPostOfficePostbox': {
			return <NearestPostboxOrPostoffice display={item.Values.PostboxOrPostoffice} />;
		}
		case 'newsletterForm': {
			return <Newsletter title={item.Values.Title} paragraph={item.Values.Paragraph} />;
		}
		case 'newsletterPopup': {
			setTimeout(() => {
				const show =
					Number(window.localStorage.getItem('hideNewsletterPopup')) + 7 * 24 * 60 * 60 * 1000 < Date.now();
				if (show) {
					window.localStorage.setItem('hideNewsletterPopup', Date.now().toString());
					dispatch(
						setActiveModal(
							NEWSLETTER_MODAL,
							item.Values.Title,
							item.Values.Image.Src,
							item.Values.Paragraph
						)
					);
				}
			}, 5000);
			return null;
		}
		case 'ctaTextOnlyBoxes': {
			return <CtaTextOnlyBoxes title={item.Values.Title} list={item.Values.CtaTextOnlyBoxes} />;
		}
		case 'ctaVerticalChecklistBoxes': {
			return <CtaVerticalChecklistBoxes title={item.Values.Title} list={item.Values.CtaVerticalChecklistBoxes} />;
		}
		case 'ctaTextOnly': {
			return (
				<CtaTextOnlyBox
					title={item.Values.Title}
					description={item.Values.Description}
					link={item.Values.Link}
				/>
			);
		}
		case 'basicRTHero': {
			return <BasicRtHero content={item} />;
		}
		case 'cookieDeclaration': {
			return <CookieDeclaration title={item.Values.Title} />;
		}
		default: {
			return null;
		}
	}
};
